import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c69f216a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixedbar"
};
const _hoisted_2 = {
  class: "fixed-content"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "pic"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pop-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "回到顶部")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, null, -1));
import { reactive } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const datalist = reactive([{
      title: '在线客服',
      desc: '实时解答产品使用问题',
      csName: 'custom'
    }, {
      title: '微信咨询',
      desc: '售前1对1产品咨询',
      csName: 'wchart',
      imgSrc: require('./img/qw-code.jpg')
    }, {
      title: '400-6868-860',
      desc: '官方电话',
      csName: 'phone'
    }, {
      title: '微信公众号',
      desc: '扫码关注亲笔签',
      csName: 'code',
      imgSrc: require('./img/gz-code.jpg')
    }]);
    const callMethod = name => {
      if (name === 'custom') {
        return TUNGEE_IM.run('show');
      }
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_back_top = _resolveComponent("a-back-top");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datalist, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_a_tooltip, {
          placement: "left",
          color: "white",
          getPopupContainer: terget => terget.parentNode.parentNode
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            class: "pop-content",
            onClick: $event => callMethod(item.csName)
          }, [item.imgSrc ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
            src: item.imgSrc
          }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.desc), 1)], 8, _hoisted_3)]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["item", item.csName]),
            onClick: $event => callMethod(item.csName)
          }, null, 10, _hoisted_7)]),
          _: 2
        }, 1032, ["getPopupContainer"]), _hoisted_8], 64);
      }), 256))]), _createVNode(_component_a_back_top, {
        class: "gotop"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tooltip, {
          placement: "left",
          color: "white",
          getPopupContainer: terget => terget.parentNode
        }, {
          title: _withCtx(() => [_hoisted_9]),
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["getPopupContainer"])]),
        _: 1
      })]);
    };
  }
};